// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-search-block {
  position: relative;
}

.header-search_input {
  margin-left: 2em;
  padding-left: 45px;
  width: 298px;
  height: 36px;
  font-size: 16px;
  border: 1px solid #cbcbcb;
  border-radius: 5px;
  outline: none;
}

.header-search_input:focus {
  border: 2px solid #434C63;
}

.header-search_icon {
  position: absolute;
  top: 25%;
  left: 15%;
  z-index: 17;
}

.profile-search-block {
  display: none;
}

@media screen  and (max-width: 1050px) {
  .header-search-block {
    display: none;
  }

  .profile-search-block {
    margin-bottom: 50px;
    display: block;
    position: relative;
  }

  .profile-search_input{
    padding-left: 60px;
    width: 100%;
    height: 53px;
    font-size: 18px;
    border: 1px solid #a2a2a2;
    border-radius: 5px;
    outline: none;
  }

  .profile-search_icon{
    position: absolute;
    top: 30%;
    left: 3%;
    z-index: 17;
  }
}

@media screen  and (max-width: 480px) {
  .profile-search-block {
    margin: 0 20px 70px 20px;
  }

  .profile-search_input{
    padding-left: 40px;
    height: 40px;
    font-size: 16px;
  }

}`, "",{"version":3,"sources":["webpack://./src/components/Search/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,WAAW;EACb;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,eAAe;EACjB;;AAEF","sourcesContent":[".header-search-block {\n  position: relative;\n}\n\n.header-search_input {\n  margin-left: 2em;\n  padding-left: 45px;\n  width: 298px;\n  height: 36px;\n  font-size: 16px;\n  border: 1px solid #cbcbcb;\n  border-radius: 5px;\n  outline: none;\n}\n\n.header-search_input:focus {\n  border: 2px solid #434C63;\n}\n\n.header-search_icon {\n  position: absolute;\n  top: 25%;\n  left: 15%;\n  z-index: 17;\n}\n\n.profile-search-block {\n  display: none;\n}\n\n@media screen  and (max-width: 1050px) {\n  .header-search-block {\n    display: none;\n  }\n\n  .profile-search-block {\n    margin-bottom: 50px;\n    display: block;\n    position: relative;\n  }\n\n  .profile-search_input{\n    padding-left: 60px;\n    width: 100%;\n    height: 53px;\n    font-size: 18px;\n    border: 1px solid #a2a2a2;\n    border-radius: 5px;\n    outline: none;\n  }\n\n  .profile-search_icon{\n    position: absolute;\n    top: 30%;\n    left: 3%;\n    z-index: 17;\n  }\n}\n\n@media screen  and (max-width: 480px) {\n  .profile-search-block {\n    margin: 0 20px 70px 20px;\n  }\n\n  .profile-search_input{\n    padding-left: 40px;\n    height: 40px;\n    font-size: 16px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
